import Link from "next/link";
import DescriptionIcon from "@mui/icons-material/Description";
import VideocamIcon from "@mui/icons-material/Videocam";
import { GridColDef } from "@mui/x-data-grid-pro";
import CampaignDetailsModal from "./CampaignDetailsModal";
import OpenModalDetailsButton from "./OpenModalDetailsButton";
import { FetchCampaignsV2Response } from "@/api/interfaces/responses/campaigns";
import { CampaignType } from "@/interfaces/campaign";

export const columns: GridColDef[] = [
  {
    field: "campaign_type",
    flex: 1,
    headerName: "Type",
    minWidth: 90,
    renderCell: (params) => {
      if (params.value === CampaignType.Document) {
        return <DescriptionIcon />;
      }
      return <VideocamIcon />;
    },
  },
  {
    flex: 2,
    field: "name",
    headerName: "Name",
    minWidth: 300,
    renderCell: (params) => (
      <Link
        href={`/search?${new URLSearchParams({ "campaign-id": params.row.id })}`}
        className="hover:underline"
      >
        {params.value}
      </Link>
    ),
  },
  {
    flex: 1,
    field: "email_cadence",
    headerName: "Notification Schedule",
    minWidth: 200,
  },
  {
    flex: 2,
    field: "creator",
    headerName: "Creator",
    minWidth: 200,
    valueGetter: (value, row) => row.creator?.email || "Unknown",
  },
  {
    flex: 1,
    field: "actions",
    headerName: "",
    minWidth: 100,
    sortable: false,
    renderCell: (params) => {
      return (
        <OpenModalDetailsButton>
          <CampaignDetailsModal
            campaign={params.row as FetchCampaignsV2Response}
          />
        </OpenModalDetailsButton>
      );
    },
  },
];
